import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { graphql, compose } from 'react-apollo';
import { injectIntl } from 'react-intl';
import s from './StaticInfoBlock.css';
import l from '../../Skeleton/Skeleton.css';
import cx from 'classnames';
//Components
import HomeKindofTrip from '../HomeKindofTrip/HomeKindofTrip';
// Skeleton Loader
import Shimmer from "../../Skeleton/Shimmer";
import HomeKindofTripSkeleton from "../../Skeleton/HomeKindofTripSkeleton";
// Graphql
import getStaticInfo from './getStaticInfo.graphql';

// Helper to get localized value from key-value data
const getLocalizedValue = (item, locale) => {
  if (!item) return '';
  const code = locale ? locale.substring(0, 2).toLowerCase() : 'es';
  if (code === 'es') return item.value || '';
  const localizedField = `value_${code}`;
  return item[localizedField] || item.value || '';
};

class StaticInfoBlock extends React.Component {

  static propTypes = {
    getImageBannerData: PropTypes.shape({
      loading: PropTypes.bool,
      getImageBanner: PropTypes.object
    }),
  };

  static defaultProps = {
    getImageBannerData: {
      loading: true
    },
  }

  render() {
    const { getStaticInfoData: { loading: getStaticInfoLoading, getStaticInfo }, locale } = this.props;
    let staticInfoCollection = {};
    let isEnabled = true; // Default to enabled
    
    getStaticInfo && getStaticInfo.length > 0 && getStaticInfo.map((item, key) => {
      if (item.name === 'isEnabled') {
        isEnabled = item.value === 'true';
      } else {
        staticInfoCollection[item.name] = getLocalizedValue(item, locale);
      }
    });

    // Don't render if disabled
    if (!getStaticInfoLoading && !isEnabled) {
      return null;
    }

    return (
      <>
        {
          getStaticInfoLoading ? <div className="hidden-xs">
            <div className={s.container}>
              <div className={cx(l.popularSkeletonTwoTitle, 'bgBlackTwo')}>
                <Shimmer />
              </div>
              <HomeKindofTripSkeleton />
            </div>
          </div> : <div className="hidden-xs">
            <HomeKindofTrip staticInfo={staticInfoCollection} />
          </div>
        }
      </>
    )
  }
}

const mapState = (state) => ({
  locale: state.intl.locale
});

export default compose(
  injectIntl,
  withStyles(s, l),
  connect(mapState),
  graphql(getStaticInfo, {
    name: 'getStaticInfoData',
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }),
)(StaticInfoBlock);
